var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    transform: "translate(-585 -442)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(325.5 -249.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(259.5 694.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.741,707.943H261.259a1.75,1.75,0,0,1-1.759-1.737v-9.968a1.751,1.751,0,0,1,1.759-1.738h16.481a1.751,1.751,0,0,1,1.759,1.738v9.968A1.75,1.75,0,0,1,277.741,707.943Zm-16.481-12.459a.766.766,0,0,0-.776.754v9.968a.766.766,0,0,0,.776.754h16.481a.766.766,0,0,0,.776-.754v-9.968a.766.766,0,0,0-.776-.754Z",
    transform: "translate(-259.5 -694.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(259.806 695.09)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.128,704.562a.491.491,0,0,1-.305-.106l-9.2-7.279a.492.492,0,0,1,.61-.772l8.9,7.038,8.9-7.038a.492.492,0,0,1,.61.772l-9.2,7.279A.491.491,0,0,1,270.128,704.562Z",
    transform: "translate(-260.434 -696.3)"
  }))), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 20,
    height: 20,
    transform: "translate(585 442)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.777df864a1049293696ba948d79914e2.svg";
export { ForwardRef as ReactComponent };